export default __webpack_public_path__ + "static/media/image2.de3d82a5.jpg";